import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// context
import { QueueProvider } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

// hooks
import {
    usePhotoModBatches,
    LoadMoreButton
} from "frontend/components/fort/mod/photos/hooks/usePhotoModBatches/index.js";
import { useBatchUploads } from "../../hooks";

// data
import { LICENSE_MAPPINGS } from "frontend/components/fort/mod/photos/constants.js";

// component
export const PhotoModQueueProvider = ({ children }) => {
    // hooks
    const { selectedBatch, uploads: uploadsObject } = useSelector(
        state => state
    );

    const { currentViewUploadIds } = useBatchUploads(selectedBatch.id);

    const batchesObject = usePhotoModBatches();

    return (
        <QueueProvider
            batchesObject={batchesObject}
            LoadMoreButton={LoadMoreButton}
            uploadsObject={uploadsObject}
            selectedBatch={selectedBatch}
            uploadType="photo"
            licenseMappings={LICENSE_MAPPINGS}
            currentViewUploadIds={currentViewUploadIds}
            showHistory={false}
        >
            {children}
        </QueueProvider>
    );
};

export default PhotoModQueueProvider;

// prop-types
PhotoModQueueProvider.propTypes = {
    children: PropTypes.any
};
